import React from 'react';
import { ContentCard, ContentWrapper } from '../../common/components/ContentCard';
import { DateRangeInput, FilterButton } from '@increasecard/typed-components';
import { Field } from '@increasecard/typed-components/dist/types/Field';
import { ActionHeader, ActionButtons, FilterGroup } from '../../common/components/ActionHeader';
import { CurrencyTabs } from '../../common/components/CurrencyTabs';
import { useTaxesScreen } from './useTaxesScreen';
import { CreateReportButton } from '../../common/components/report/CreateReportButton';
import { TaxesSummaryTable } from './components/TaxesSummaryTable';

export function TaxesScreen() {
  const {
    country,
    currencies,
    currency,
    setCurrency,
    filters,
    setFilters,
    dateRange,
    setDateRange,
    filterFields,
    taxes,
    handleCreateReport,
    t
  } = useTaxesScreen();

  return (
    <ContentCard>
      {currencies && currencies.length > 1 && currency && (
        <CurrencyTabs currencies={currencies} onChange={setCurrency} value={currency} />
      )}
      <ContentWrapper>
        <ActionHeader>
          <FilterGroup>
            <DateRangeInput
              id="taxesDateFilter"
              label=""
              labelHidden
              onChange={setDateRange}
              style={{ width: 280 }}
              value={dateRange}
            />
            {filterFields && (
              <FilterButton
                fields={filterFields as Field[]}
                onChange={setFilters}
                value={filters}
              />
            )}
          </FilterGroup>
          <ActionButtons>
            <CreateReportButton
              onCreateReport={handleCreateReport}
              targetText={t('taxes')}
              translationFunction={t}
            />
          </ActionButtons>
        </ActionHeader>
        <TaxesSummaryTable country={country} currency={currency} taxes={taxes} />
      </ContentWrapper>
    </ContentCard>
  );
}
